import { render, staticRenderFns } from "./SchemaInfo.vue?vue&type=template&id=337f992a"
import script from "./SchemaInfo.vue?vue&type=script&lang=js"
export * from "./SchemaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports